import React, { useContext } from 'react';
import { ToolbarContext } from 'ricos-context';
import { ToolbarButton } from 'wix-rich-content-toolbars-ui';

const RemoveLinkButton = ({ toolbarItem }) => {
  var _a, _b, _c;
  const { t, isMobile } = useContext(ToolbarContext);
  const tooltip = t((_a = toolbarItem.presentation) == null ? void 0 : _a.tooltip);
  const dataHook = (_b = toolbarItem.presentation) == null ? void 0 : _b.dataHook;
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      isMobile,
      tooltip,
      onClick: () => {
        toolbarItem.commands.click();
      },
      Icon: (_c = toolbarItem.presentation) == null ? void 0 : _c.icon,
      dataHook
    }
  );
};

export { RemoveLinkButton };
//# sourceMappingURL=remove-link-button.js.map
